/** Log levels with numeric severity values (higher = more severe). */
export const levels = {
    error: 50,
    warn: 40,
    info: 20,
    debug: 10,
    trace: 0,
};
export const now = () => typeof performance !== "undefined" && typeof performance.now === "function"
    ? performance.now() + performance.timeOrigin
    : Date.now();
//# sourceMappingURL=lib.js.map